<template>
    <v-card flat :class="{'pl-6': !xs, 'pr-4': !xs, 'pt-4': xl, 'score-trans': true}" :height="getCardHeight()">
        <right_panel_performance ref="ytd_performance"/>
    </v-card>
</template>

<script>
    
    import mxscreensize from '@/components/js/screensize';
    import right_panel_performance from '@/components/dashboard/sections/right_panel_performance_table.vue';

    export default {    
        props: {
            height_correction: Number,
        },                
        components: {
            right_panel_performance,
        }, 
        mounted() {            
            this.load(0); 
        },  
        mixins:[mxscreensize],                
        computed:{
            xs: function(){
                return this.$vuetify.breakpoint.name === 'xs';
            },
            xl: function(){
                return this.$vuetify.breakpoint.name === 'xl';
            },            
        },            
        methods: {   
            getCardHeight(){
                return (((this.wInnerHeight - (typeof this.height_correction === 'undefined' ? 0 : this.height_correction)) / 5) * 1);
            },    
            delay(time){
                return new Promise(resolve => setTimeout(resolve, time));
            },     
            getYearlyPerformance(year){
                return this.$axios
                    .post("ares/json/ares/syst/dashboard/getYearToDatePerformancev1.p", {
                        header: {
                            token: this.$session.get("ARES"),
                            clientSessionId: this.$session.id(),
                            request: "getYearToDatePerformance"
                        },
                        getYearToDatePerformance: {
                            year: year
                        }                        
                    });
            },   
            async load(arg){
                let year = new Date().getFullYear();
                console.log('(re) load right panel extended performance data (promise.all)', arg);
                if(arg===0){                    
                    const promise1 = this.getYearlyPerformance(year);
                    const promise2 = this.getYearlyPerformance(year - 1);
                    Promise.all([promise1, promise2]).then(resp => {
                        this.$refs.ytd_performance.loadPerformance(resp[0].data.getYearToDatePerformance, resp[1].data.getYearToDatePerformance);
                    });                    
                } else{
                    const promise1 = await this.getYearlyPerformance(year);
                    this.$refs.ytd_performance.loadPerformance(promise1.data.getYearToDatePerformance, null);
                }            
            },       
       }        
    }
</script>
<style scoped>

.score-trans {
        background: transparent !important;
    } 

</style>
